import { type FC } from "react";
import * as styles from "./styles.css";

export const Footer: FC = () => (
  <footer className={styles.footer}>&copy; REJOB Co.,Ltd. All Rights Reserved.</footer>
);
